import { TrendingUp } from 'lucide-react';
import { Badge } from '../../../../components/ui/badge';

export function WelcomeHero() {
  return (
    <div className="space-y-4 text-text-primary">
      <Badge
        variant="default"
        className="bg-[#FBFDFC99] h-[30px] py-1 px-[6px] font-medium text-[13px] transition-transform ease-in-out rounded text-primary hover:bg-[#FBFDFC99] hover:scale-105"
      >
        <span className="flex items-center gap-2">
          <TrendingUp size={16} className="text-primary" />
          Trending
        </span>
      </Badge>
      <div className="space-y-6">
        <h1 className="text-2xl md:text-5xl font-medium text-text-primary lg:max-w-[400px] leading-tight lg:leading-[60px]">
          Welcome to Social Media Generator
        </h1>
        <p className="text-sm lg:text-xl font-normal text-text-primary md:w-[360px] mb-6 lg:mb-0">
          Running out of ideas for social media content - we can generate
          wholesome ideas on different topics. Whether you are promoting your
          brand, engaging with followers, or sharing updates, this tool
          generates posts.
        </p>
      </div>
    </div>
  );
}
